/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse,
  HttpHeaders, HttpParams ,HttpXsrfTokenExtractor} from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

import { EInvoiceSearch } from '../models/einvoice-search';
import { ReceiptView } from '../models/receipt-view';
import { ReceiptForm } from '../models/receipt-form';
import { ReceiptAllForm } from '../models/receipt-all-form';
import { UpdateShiftForm } from '../models/update-shift-form';
import { ReceiptDetail } from '../models/receipt-detail';
import { RpTicketDestroyForm } from '../models/rp-ticket-destroy-form';
import { TicketDestroyView } from '../models/ticket-destroy-view';
import { TicketDestroyForm } from '../models/ticket-destroy-form';
import { inline_response_200 } from '../models/inline-_response-_200';
import { TicketDestroyAccept } from '../models/ticket-destroy-accept';
import { RpShiftDestroyForm } from '../models/rp-shift-destroy-form';
import { ShiftDestroyView } from '../models/shift-destroy-view';
import { ShiftDestroyForm } from '../models/shift-destroy-form';
import { ShiftDestroyAccept } from '../models/shift-destroy-accept';
import { PaymentForm } from '../models/payment-form';
import { RpStaffForm } from '../models/rp-staff-form';
import { StaffView } from '../models/staff-view';
import { RpDailyForm } from '../models/rp-daily-form';
import { DailyView } from '../models/daily-view';
import { RpVehicleForm } from '../models/rp-vehicle-form';
import { VehicleView } from '../models/vehicle-view';
import { RpVehicleAllForm } from '../models/rp-vehicle-all-form';
import { VehicleAllView } from '../models/vehicle-all-view';
import { RpTicketsForm } from '../models/rp-tickets-form';
import { TicketPrint } from '../models/ticket-print';
import { TicketView } from '../models/ticket-view';
import { CardView } from '../models/card-view';
import { RpCardForm } from '../models/rp-card-form';
import { CardMonthGeneralView } from '../models/card-month-general-view';
import { CardMonthGeneralForm } from '../models/card-month-general-form';
import { CardMonthRevenueView } from '../models/card-month-revenue-view';
import { CardMonthRevenueForm } from '../models/card-month-revenue-form';
import { CardMonthStaffView } from '../models/card-month-staff-view';
import { CardMonthStaffForm } from '../models/card-month-staff-form';
import { CardMonthGroupBusStationView } from '../models/card-month-group-bus-station-view';
import { CardMonthGroupBusStationForm } from '../models/card-month-group-bus-station-form';
import { CardExemption } from '../models/card-exemption';
import { CardExemptionForm } from '../models/card-exemption-form';
import { RpInvoiceForm } from '../models/rp-invoice-form';
import { NumberConvert } from '../models/number-convert';
import { TransactionDetailSearch } from '../models/transaction-detail-search';
import { TransactionOnline } from '../models/transaction-online';
import { RpTripView } from '../models/rp-trip-view';
import { RpTripForm } from '../models/rp-trip-form';
import { RpTimeKeepingForm } from '../models/rp-time-keeping-form';
import { RpOutputView } from '../models/rp-output-view';
import { RpOutputForm } from '../models/rp-output-form';
import { ShiftSupervisorView } from '../models/shift-supervisor-view';
import { ShiftSupervisorForm } from '../models/shift-supervisor-form';
import { VehicleRoutePeriodView } from '../models/vehicle-route-period-view';
import { VehicleRoutePeriodForm } from '../models/vehicle-route-period-form';
import { VehicleActivityView } from '../models/vehicle-activity-view';
import { VehicleActivityForm } from '../models/vehicle-activity-form';
import { EInvoiceForm } from '../models/einvoice-form';
import { EInvoicePush } from '../models/einvoice-pushhilo';
import { EditEinvoiceForm } from '../models/edit-einvoice-form';
@Injectable()
export class ManagerReportsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param body - undefined
   */
  managerReportsViewReceiptResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if(body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.vehicle_id != null) __params = __params.set("vehicle_id", body.vehicle_id.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    if (body.type != null) __params = __params.set("type", body.type.toString());
    if (body.ticket_counters_id != null) __params = __params.set("ticket_counters_id", body.ticket_counters_id.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/summary/receipt`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewReceipt(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsViewReceiptResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewAllReceiptResponse(body?: ReceiptAllForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/receipt/viewall`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewAllReceipt(body?: ReceiptAllForm): Observable<ReceiptView[]> {
    return this.managerReportsViewAllReceiptResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsTicketOnlineResponse(body?: any): Observable<HttpResponse<any[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/ticket-online`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: any[] = null;
        _body = _resp.body as any[]
        return _resp.clone({body: _body}) as HttpResponse<any[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsTicketOnline(body?: any): Observable<any[]> {
    return this.managerReportsTicketOnlineResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerDownloadTicketOnlineResponse(
    body: any
  ): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;

    let req = new HttpRequest<any>(
      "post",
      this.rootUrl + `/manager/ticket-online/download`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob"
      }
    );
    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string;
        return _resp.clone({ body: _body }) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewNotCollectMoneyReceiptResponse(body?: ReceiptAllForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/receipt/viewnotcollectmoney`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewNotCollectMoneyReceipt(body?: ReceiptAllForm): Observable<ReceiptView[]> {
    return this.managerReportsViewNotCollectMoneyReceiptResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportReceiptResponse(body?: any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/receipt/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportReceipt(body?: any): Observable<string> {
    return this.managerReportsExportReceiptResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  updateShiftsResponse(body?: UpdateShiftForm): Observable<HttpResponse<void>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "PATCH",
      this.rootUrl + `/manager/reports/receipt/shifts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: void = null;

        return _resp.clone({body: _body}) as HttpResponse<void>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  updateShifts(body?: UpdateShiftForm): Observable<void> {
    return this.updateShiftsResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param shiftId - undefined
   */
  managerReportsExportReceiptTransactionByShiftIdResponse(shiftId: number): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/receipt/${shiftId}/transaction`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param shiftId - undefined
   */
  managerReportsExportReceiptTransactionByShiftId(shiftId: number): Observable<string> {
    return this.managerReportsExportReceiptTransactionByShiftIdResponse(shiftId).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param shiftId - undefined
   */
  managerReportsGetReceiptDetailByShiftIdResponse(shiftId: number): Observable<HttpResponse<ReceiptDetail>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/receipt/shift/${shiftId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptDetail = null;
        _body = _resp.body as ReceiptDetail
        return _resp.clone({body: _body}) as HttpResponse<ReceiptDetail>;
      })
    );
  }

  /**
   * @param shiftId - undefined
   */
  managerReportsGetReceiptDetailByShiftId(shiftId: number): Observable<ReceiptDetail> {
    return this.managerReportsGetReceiptDetailByShiftIdResponse(shiftId).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
   managerReportsGetReceiptDetailByUserResponse(body:any): Observable<HttpResponse<ReceiptDetail>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = body;
    //if(body.ids!=null)__params=__params.set("ids",[body.ids]);
    // if(vehicle_id!=null)__params=__params.set("vehicle_id",vehicle_id.toString());
    // if(date!=null)__params=__params.set("date",date.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/receipt/details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptDetail = null;
        _body = _resp.body as ReceiptDetail
        return _resp.clone({body: _body}) as HttpResponse<ReceiptDetail>;
      })
    );
  }

  /**
   * @param shiftId - undefined
   */
  managerReportsGetReceiptDetailByUser(body?:any): Observable<ReceiptDetail> {
    return this.managerReportsGetReceiptDetailByUserResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  
  managerReportsGetInvoiceDetailByUserResponse(body? : any): Observable<HttpResponse<ReceiptDetail>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = body;
    // if(user_id!=null)__params=__params.set("user_id",user_id.toString());
    // if(vehicle_id!=null)__params=__params.set("vehicle_id",vehicle_id.toString());
    // if(hilo_id!=null)__params=__params.set("hilo_id",hilo_id.toString());
    // if(date!=null)__params=__params.set("date",date.toString());
    // if(ticket_type_id!=null)__params=__params.set("ticket_type_id",ticket_type_id.toString());
    // if(seri_from!=null)__params=__params.set("seri_from",seri_from.toString());
    // if(seri_to!=null)__params=__params.set("seri_to",seri_to.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/invoice/details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptDetail = null;
        _body = _resp.body as ReceiptDetail
        return _resp.clone({body: _body}) as HttpResponse<ReceiptDetail>;
      })
    );
  }

  /**
   * @param shiftId - undefined
   */
  managerReportsGetInvoiceDetailByUser(body?: any): Observable<ReceiptDetail> {
    return this.managerReportsGetInvoiceDetailByUserResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsAddTicketDestroyInTransactionResponse(body?: RpTicketDestroyForm): Observable<HttpResponse<void>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/receipt/shift/transaction/ticketDestroy`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: void = null;

        return _resp.clone({body: _body}) as HttpResponse<void>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsAddTicketDestroyInTransaction(body?: RpTicketDestroyForm): Observable<void> {
    return this.managerReportsAddTicketDestroyInTransactionResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewTicketDestroyResponse(body?: TicketDestroyForm): Observable<HttpResponse<TicketDestroyView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/receipt/shift/transaction/ticketDestroy/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: TicketDestroyView[] = null;
        _body = _resp.body as TicketDestroyView[]
        return _resp.clone({body: _body}) as HttpResponse<TicketDestroyView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewTicketDestroy(body?: TicketDestroyForm): Observable<TicketDestroyView[]> {
    return this.managerReportsViewTicketDestroyResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsAcceptTicketDestroyResponse(body?: TicketDestroyAccept): Observable<HttpResponse<inline_response_200>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/manager/reports/receipt/shift/transaction/ticketDestroy/accept`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: inline_response_200 = null;
        _body = _resp.body as inline_response_200
        return _resp.clone({body: _body}) as HttpResponse<inline_response_200>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsAcceptTicketDestroy(body?: TicketDestroyAccept): Observable<inline_response_200> {
    return this.managerReportsAcceptTicketDestroyResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsAddShiftDestroyResponse(body?: RpShiftDestroyForm): Observable<HttpResponse<void>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/receipt/shift/shiftDestroys`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: void = null;

        return _resp.clone({body: _body}) as HttpResponse<void>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsAddShiftDestroy(body?: RpShiftDestroyForm): Observable<void> {
    return this.managerReportsAddShiftDestroyResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewShiftDestroysResponse(body?: ShiftDestroyForm): Observable<HttpResponse<ShiftDestroyView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/receipt/shift/shiftDestroys/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ShiftDestroyView[] = null;
        _body = _resp.body as ShiftDestroyView[]
        return _resp.clone({body: _body}) as HttpResponse<ShiftDestroyView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewShiftDestroys(body?: ShiftDestroyForm): Observable<ShiftDestroyView[]> {
    return this.managerReportsViewShiftDestroysResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsAcceptShiftDestroyResponse(body?: ShiftDestroyAccept): Observable<HttpResponse<inline_response_200>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/manager/reports/receipt/shift/shiftDestroys/accept`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: inline_response_200 = null;
        _body = _resp.body as inline_response_200
        return _resp.clone({body: _body}) as HttpResponse<inline_response_200>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsAcceptShiftDestroy(body?: ShiftDestroyAccept): Observable<inline_response_200> {
    return this.managerReportsAcceptShiftDestroyResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewPaymentResponse(body?: PaymentForm): Observable<HttpResponse<object[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/payment/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: object[] = null;
        _body = _resp.body as object[]
        return _resp.clone({body: _body}) as HttpResponse<object[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewPayment(body?: PaymentForm): Observable<object[]> {
    return this.managerReportsViewPaymentResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param paymentId - undefined
   */
  managerReportsExportPaymentByPaymentIdResponse(paymentId: number): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/payment/export/${paymentId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param paymentId - undefined
   */
  managerReportsExportPaymentByPaymentId(paymentId: number): Observable<string> {
    return this.managerReportsExportPaymentByPaymentIdResponse(paymentId).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportStaffResponse(body?: RpStaffForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/staff/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportStaff(body?: RpStaffForm): Observable<string> {
    return this.managerReportsExportStaffResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewStaffResponse(body?: RpStaffForm): Observable<HttpResponse<StaffView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/staff/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: StaffView[] = null;
        _body = _resp.body as StaffView[]
        return _resp.clone({body: _body}) as HttpResponse<StaffView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewStaff(body?: RpStaffForm): Observable<StaffView[]> {
    return this.managerReportsViewStaffResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportDailyResponse(body?: RpDailyForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/daily/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportDaily(body?: RpDailyForm): Observable<string> {
    return this.managerReportsExportDailyResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewDailyResponse(body?: RpDailyForm): Observable<HttpResponse<DailyView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/daily/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: DailyView[] = null;
        _body = _resp.body as DailyView[]
        return _resp.clone({body: _body}) as HttpResponse<DailyView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewDaily(body?: RpDailyForm): Observable<DailyView[]> {
    return this.managerReportsViewDailyResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportVehiclesResponse(body?: RpVehicleForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/vehicles/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportVehicles(body?: RpVehicleForm): Observable<string> {
    return this.managerReportsExportVehiclesResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewVehiclesResponse(body?: RpVehicleForm): Observable<HttpResponse<VehicleView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/vehicles/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: VehicleView[] = null;
        _body = _resp.body as VehicleView[]
        return _resp.clone({body: _body}) as HttpResponse<VehicleView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewVehicles(body?: RpVehicleForm): Observable<VehicleView[]> {
    return this.managerReportsViewVehiclesResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportVehicleAllResponse(body?: RpVehicleAllForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/vehicleall/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportVehicleAll(body?: RpVehicleAllForm): Observable<string> {
    return this.managerReportsExportVehicleAllResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewVehicleAllResponse(body?: RpVehicleAllForm): Observable<HttpResponse<VehicleAllView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/vehicleall/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: VehicleAllView[] = null;
        _body = _resp.body as VehicleAllView[]
        return _resp.clone({body: _body}) as HttpResponse<VehicleAllView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewVehicleAll(body?: RpVehicleAllForm): Observable<VehicleAllView[]> {
    return this.managerReportsViewVehicleAllResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportVehicleByPeriodResponse(body?: RpVehicleAllForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/vehicleperiod/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportVehicleByPeriod(body?: RpVehicleAllForm): Observable<string> {
    return this.managerReportsExportVehicleByPeriodResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewVehicleByPeriodResponse(body?: RpVehicleAllForm): Observable<HttpResponse<VehicleAllView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/vehicleperiod/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: VehicleAllView[] = null;
        _body = _resp.body as VehicleAllView[]
        return _resp.clone({body: _body}) as HttpResponse<VehicleAllView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewVehicleByPeriod(body?: RpVehicleAllForm): Observable<VehicleAllView[]> {
    return this.managerReportsViewVehicleByPeriodResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportTicketsResponse(body?: RpTicketsForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/tickets/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportTickets(body?: RpTicketsForm): Observable<string> {
    return this.managerReportsExportTicketsResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportTicketsByStationResponse(body?: RpTicketsForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/tickets/exportTicketByStation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportTicketsByStation(body?: RpTicketsForm): Observable<string> {
    return this.managerReportsExportTicketsByStationResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsPrintTicketsResponse(body?: RpTicketsForm): Observable<HttpResponse<TicketPrint[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/tickets/print`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: TicketPrint[] = null;
        _body = _resp.body as TicketPrint[]
        return _resp.clone({body: _body}) as HttpResponse<TicketPrint[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsPrintTickets(body?: RpTicketsForm): Observable<TicketPrint[]> {
    return this.managerReportsPrintTicketsResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewTicketsResponse(body?: RpTicketsForm): Observable<HttpResponse<TicketView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/tickets/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: TicketView[] = null;
        _body = _resp.body as TicketView[]
        return _resp.clone({body: _body}) as HttpResponse<TicketView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewTickets(body?: RpTicketsForm): Observable<TicketView[]> {
    return this.managerReportsViewTicketsResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewTicketsByStationResponse(body?: RpTicketsForm): Observable<HttpResponse<TicketView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/tickets/viewByStation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: TicketView[] = null;
        _body = _resp.body as TicketView[]
        return _resp.clone({body: _body}) as HttpResponse<TicketView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewTicketsByStation(body?: RpTicketsForm): Observable<TicketView[]> {
    return this.managerReportsViewTicketsByStationResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewCardResponse(body?: RpCardForm): Observable<HttpResponse<CardView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/card/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: CardView[] = null;
        _body = _resp.body as CardView[]
        return _resp.clone({body: _body}) as HttpResponse<CardView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewCard(body?: RpCardForm): Observable<CardView[]> {
    return this.managerReportsViewCardResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportCardResponse(body?: RpCardForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/card/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportCard(body?: RpCardForm): Observable<string> {
    return this.managerReportsExportCardResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewCardMonthForGeneralResponse(body?: CardMonthGeneralForm): Observable<HttpResponse<CardMonthGeneralView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/cardMonth/general/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: CardMonthGeneralView[] = null;
        _body = _resp.body as CardMonthGeneralView[]
        return _resp.clone({body: _body}) as HttpResponse<CardMonthGeneralView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewCardMonthForGeneral(body?: CardMonthGeneralForm): Observable<CardMonthGeneralView[]> {
    return this.managerReportsViewCardMonthForGeneralResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportCardMonthForGeneralResponse(body?: CardMonthGeneralForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/cardMonth/general/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportCardMonthForGeneral(body?: CardMonthGeneralForm): Observable<string> {
    return this.managerReportsExportCardMonthForGeneralResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewCardMonthRevenueResponse(body?: CardMonthRevenueForm): Observable<HttpResponse<CardMonthRevenueView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/cardMonth/revenue/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: CardMonthRevenueView[] = null;
        _body = _resp.body as CardMonthRevenueView[]
        return _resp.clone({body: _body}) as HttpResponse<CardMonthRevenueView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewCardMonthRevenue(body?: CardMonthRevenueForm): Observable<CardMonthRevenueView[]> {
    return this.managerReportsViewCardMonthRevenueResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportCardMonthRevenueResponse(body?: CardMonthRevenueForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/cardMonth/revenue/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportCardMonthRevenue(body?: CardMonthRevenueForm): Observable<string> {
    return this.managerReportsExportCardMonthRevenueResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewCardMonthByStaffResponse(body?: CardMonthStaffForm): Observable<HttpResponse<CardMonthStaffView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/cardMonth/staff/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: CardMonthStaffView[] = null;
        _body = _resp.body as CardMonthStaffView[]
        return _resp.clone({body: _body}) as HttpResponse<CardMonthStaffView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewCardMonthByStaff(body?: CardMonthStaffForm): Observable<CardMonthStaffView[]> {
    return this.managerReportsViewCardMonthByStaffResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportCardMonthByStaffResponse(body?: CardMonthStaffForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/cardMonth/staff/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportCardMonthByStaff(body?: CardMonthStaffForm): Observable<string> {
    return this.managerReportsExportCardMonthByStaffResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewCardMonthByGroupBusStationResponse(body?: CardMonthGroupBusStationForm): Observable<HttpResponse<CardMonthGroupBusStationView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/cardMonthGroupBusStation/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: CardMonthGroupBusStationView[] = null;
        _body = _resp.body as CardMonthGroupBusStationView[]
        return _resp.clone({body: _body}) as HttpResponse<CardMonthGroupBusStationView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewCardMonthByGroupBusStation(body?: CardMonthGroupBusStationForm): Observable<CardMonthGroupBusStationView[]> {
    return this.managerReportsViewCardMonthByGroupBusStationResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportCardMonthByGroupBusStationResponse(body?: CardMonthGroupBusStationForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/cardMonthGroupBusStation/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportCardMonthByGroupBusStation(body?: CardMonthGroupBusStationForm): Observable<string> {
    return this.managerReportsExportCardMonthByGroupBusStationResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewCardExemptionResponse(body?: CardExemptionForm): Observable<HttpResponse<CardExemption[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/cardExemption/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: CardExemption[] = null;
        _body = _resp.body as CardExemption[]
        return _resp.clone({body: _body}) as HttpResponse<CardExemption[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewCardExemption(body?: CardExemptionForm): Observable<CardExemption[]> {
    return this.managerReportsViewCardExemptionResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportCardExemptionResponse(body?: CardExemptionForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/cardExemption/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportCardExemption(body?: CardExemptionForm): Observable<string> {
    return this.managerReportsExportCardExemptionResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportInvoicesResponse(body?: RpInvoiceForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/invoices/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportInvoices(body?: RpInvoiceForm): Observable<string> {
    return this.managerReportsExportInvoicesResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsConvertNumberToStringResponse(body?: NumberConvert): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/receipt/convert`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsConvertNumberToString(body?: NumberConvert): Observable<string> {
    return this.managerReportsConvertNumberToStringResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerTransactionDetailSearchResponse(body?: TransactionDetailSearch): Observable<HttpResponse<ReceiptDetail[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/transactiondetail/search`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptDetail[] = null;
        _body = _resp.body as ReceiptDetail[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptDetail[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerTransactionDetailSearch(body?: TransactionDetailSearch): Observable<ReceiptDetail[]> {
    return this.managerTransactionDetailSearchResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewTransactionOnlineResponse(body?: TransactionOnline): Observable<HttpResponse<ReceiptDetail[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/transaction/online/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptDetail[] = null;
        _body = _resp.body as ReceiptDetail[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptDetail[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewTransactionOnline(body?: TransactionOnline): Observable<ReceiptDetail[]> {
    return this.managerReportsViewTransactionOnlineResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportTransactionOnlineResponse(body?: TransactionOnline): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/transaction/online/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportTransactionOnline(body?: TransactionOnline): Observable<string> {
    return this.managerReportsExportTransactionOnlineResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerTransactionDetailReportResponse(body?: TransactionDetailSearch): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/transactiondetail/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerTransactionDetailReport(body?: TransactionDetailSearch): Observable<string> {
    return this.managerTransactionDetailReportResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewTripResponse(body?: RpTripForm): Observable<HttpResponse<RpTripView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/trip/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: RpTripView[] = null;
        _body = _resp.body as RpTripView[]
        return _resp.clone({body: _body}) as HttpResponse<RpTripView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewTrip(body?: RpTripForm): Observable<RpTripView[]> {
    return this.managerReportsViewTripResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportTripResponse(body?: RpTripForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/trip/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportTrip(body?: RpTripForm): Observable<string> {
    return this.managerReportsExportTripResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportTripTimeDetailResponse(body?: RpTripForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/trip/detail/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportTripTimeDetail(body?: RpTripForm): Observable<string> {
    return this.managerReportsExportTripTimeDetailResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportTimeKeepingResponse(body?: RpTimeKeepingForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/timekeeping/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportTimeKeeping(body?: RpTimeKeepingForm): Observable<string> {
    return this.managerReportsExportTimeKeepingResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewOutputByVehicleResponse(body?: RpOutputForm): Observable<HttpResponse<RpOutputView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/outputVehicle/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: RpOutputView[] = null;
        _body = _resp.body as RpOutputView[]
        return _resp.clone({body: _body}) as HttpResponse<RpOutputView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewOutputByVehicle(body?: RpOutputForm): Observable<RpOutputView[]> {
    return this.managerReportsViewOutputByVehicleResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportOutputByVehicleResponse(body?: RpOutputForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/outputVehicle/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportOutputByVehicle(body?: RpOutputForm): Observable<string> {
    return this.managerReportsExportOutputByVehicleResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewShiftSupervisorResponse(body?: ShiftSupervisorForm): Observable<HttpResponse<ShiftSupervisorView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/shiftSupervisor/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ShiftSupervisorView[] = null;
        _body = _resp.body as ShiftSupervisorView[]
        return _resp.clone({body: _body}) as HttpResponse<ShiftSupervisorView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewShiftSupervisor(body?: ShiftSupervisorForm): Observable<ShiftSupervisorView[]> {
    return this.managerReportsViewShiftSupervisorResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportShiftSupervisorResponse(body?: ShiftSupervisorForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/shiftSupervisor/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportShiftSupervisor(body?: ShiftSupervisorForm): Observable<string> {
    return this.managerReportsExportShiftSupervisorResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewVehicleRoutePriodResponse(body?: VehicleRoutePeriodForm): Observable<HttpResponse<VehicleRoutePeriodView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/vehicleroutepriod/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: VehicleRoutePeriodView[] = null;
        _body = _resp.body as VehicleRoutePeriodView[]
        return _resp.clone({body: _body}) as HttpResponse<VehicleRoutePeriodView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewVehicleRoutePriod(body?: VehicleRoutePeriodForm): Observable<VehicleRoutePeriodView[]> {
    return this.managerReportsViewVehicleRoutePriodResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportVehicleRoutePriodResponse(body?: VehicleRoutePeriodForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/vehicleroutepriod/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportVehicleRoutePriod(body?: VehicleRoutePeriodForm): Observable<string> {
    return this.managerReportsExportVehicleRoutePriodResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsViewVehicleActivityResponse(body?: VehicleActivityForm): Observable<HttpResponse<VehicleActivityView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/vehicle-activity/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: VehicleActivityView[] = null;
        _body = _resp.body as VehicleActivityView[]
        return _resp.clone({body: _body}) as HttpResponse<VehicleActivityView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsViewVehicleActivity(body?: VehicleActivityForm): Observable<VehicleActivityView[]> {
    return this.managerReportsViewVehicleActivityResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportVehicleActivityResponse(body?: VehicleActivityForm): Observable<HttpResponse<string[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/vehicle-activity/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string[] = null;
        _body = _resp.body as string[]
        return _resp.clone({body: _body}) as HttpResponse<string[]>;
      })
    );
  }

  managerlistEinvoiceResponse(params: EInvoiceForm): Observable<HttpResponse<EInvoiceSearch[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.user_id != null) __params = __params.set("user_id", params.user_id.toString());
    if (params.from_date != null) __params = __params.set("from_date", params.from_date.toString());
    if (params.to_date != null) __params = __params.set("to_date", params.to_date.toString());
    if (params.ticket_type_id != null) __params = __params.set("ticket_type_id", params.ticket_type_id.toString());
    if (params.ticket_counters_id != null) __params = __params.set("ticket_counters_id", params.ticket_counters_id.toString());
    if (params.status != null) __params = __params.set("status", params.status.toString());
    if (params.page != null) __params = __params.set("page", params.page.toString());
    if (params.limit != null) __params = __params.set("limit", params.limit.toString());

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/summary/invoice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: EInvoiceSearch[] = null;
        _body = _resp.body as EInvoiceSearch[]
        return _resp.clone({ body: _body }) as HttpResponse<EInvoiceSearch[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerlistEinvoice(params: EInvoiceForm): Observable<EInvoiceSearch[]> {
    return this.managerlistEinvoiceResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerlistEinvoiceGroupResponse(params: EInvoiceForm): Observable<HttpResponse<EInvoiceSearch[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.from_date != null) __params = __params.set("from_date", params.from_date.toString());
    if (params.to_date != null) __params = __params.set("to_date", params.to_date.toString());
    if (params.page != null) __params = __params.set("page", params.page.toString());
    if (params.limit != null) __params = __params.set("limit", params.limit.toString());

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/e-invoice-groups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: EInvoiceSearch[] = null;
        _body = _resp.body as EInvoiceSearch[]
        return _resp.clone({ body: _body }) as HttpResponse<EInvoiceSearch[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerlistEinvoiceGroup(params: EInvoiceForm): Observable<EInvoiceSearch[]> {
    return this.managerlistEinvoiceGroupResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerPushTicketResponse(body?: EInvoicePush): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/invoice/push`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
   managerPushTicket(body?: EInvoicePush): Observable<string> {
    return this.managerPushTicketResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
  managerReportsExportVehicleActivity(body?: VehicleActivityForm): Observable<string[]> {
    return this.managerReportsExportVehicleActivityResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  managerReportsTicketDestroyResponse(body?:TicketDestroyForm):Observable<HttpResponse<TicketDestroyView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body=body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/receipt/details/cancel `,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

      return this.http.request<any>(req).pipe(
        filter(_r => _r instanceof HttpResponse),
        map(_r => {
          let _resp = _r as HttpResponse<any>;
          let _body: TicketDestroyView[] = null;
          _body = _resp.body as TicketDestroyView[]
          return _resp.clone({body: _body}) as HttpResponse<TicketDestroyView[]>;
        })
      );
  }

  /**
   * @param body - undefined
   */
   managerReportsTicketDestroy(body?: TicketDestroyForm): Observable<TicketDestroyView[]>  {
    return this.managerReportsTicketDestroyResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
   managerReportsExportDetailTicketReceiptResponse(body?: any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/receipt/export/detail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
   managerReportsExportDetailTicketReceipt(body?: any): Observable<string> {
    return this.managerReportsExportDetailTicketReceiptResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsExportReceiptSummaryResponse(body?: any): Observable<HttpResponse<string>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = body;
    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manager/summary/receipt/export/summary`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        const _body: string = _resp.body as string;
        return _resp.clone({ body: _body }) as HttpResponse<string>;
      })
    );
  }

  managerReportsExportReceiptSummary(body?: any): Observable<string> {
    return this.managerReportsExportReceiptSummaryResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * @param body - undefined
   */
   managerReportsExportTicketReceiptResponse(body?: ReceiptForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/receipt/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
   managerReportsExportTicketReceipt(body?: ReceiptForm): Observable<string> {
    return this.managerReportsExportTicketReceiptResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */

   managerReportsExportDetailEinvoiceResponse(body?: ReceiptForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/einvoice/export/detail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
    
  }
  /**
   * @param body - undefined
   */
   managerReportsExportDetailEinvoice(body?: ReceiptForm): Observable<string> {
    return this.managerReportsExportDetailEinvoiceResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param body - undefined
   */
   managerReportsTicketSaleSummaryResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if (body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.month != null) __params = __params.set("month", body.month.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.vehicle_id != null) __params = __params.set("vehicle_id", body.vehicle_id.toString());
    if(body.price_id != null) __params = __params.set("ticket_price_id", body.price_id.toString());
    if(body.ticket_counters_id != null) __params = __params.set("ticket_counters_id", body.ticket_counters_id.toString());
    if (body.foreigner != null && body.foreigner !== '') __params = __params.set("foreigner", body.foreigner.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/tickets/ticketsales/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsTicketSaleSummary(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsTicketSaleSummaryResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsTicketGroupSaleSummaryResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if (body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.month != null) __params = __params.set("month", body.month.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.vehicle_id != null) __params = __params.set("vehicle_id", body.vehicle_id.toString());
    if(body.price_id != null) __params = __params.set("ticket_price_id", body.price_id.toString());
    if(body.ticket_counters_id != null) __params = __params.set("ticket_counters_id", body.ticket_counters_id.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/tickets/ticket-group-sales/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsTicketGroupSaleSummary(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsTicketGroupSaleSummaryResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsTicketSaleByBuyerResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if (body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.month != null) __params = __params.set("month", body.month.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.vehicle_id != null) __params = __params.set("vehicle_id", body.vehicle_id.toString());
    if(body.price_id != null) __params = __params.set("ticket_price_id", body.price_id.toString());
    if(body.ticket_counters_id != null) __params = __params.set("ticket_counters_id", body.ticket_counters_id.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/tickets/ticket-sale-buyer/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsTicketSaleByBuyer(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsTicketSaleByBuyerResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsTicketCheckResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if (body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.price_id != null) __params = __params.set("ticket_price_id", body.price_id.toString());
    if(body.type_check != null) __params = __params.set("type_check", body.type_check.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/tickets/check/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsTicketCheck(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsTicketCheckResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsTicketsByCountryResponse(body?: ReceiptForm): Observable<HttpResponse<Array<{ country: string; count: number }>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (body.date_from != null) {
      __params = __params.set('from_date', body.date_from.toString());
    }
    if (body.date_to != null) {
      __params = __params.set('to_date', body.date_to.toString());
    }
    if ((body as any).market_type != null && (body as any).market_type !== '') {
      __params = __params.set('market_type', (body as any).market_type.toString());
    }
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/by-country`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: Array<{ country: string; count: number }> = null;
        _body = _resp.body as Array<{ country: string; count: number }>;
        return _resp.clone({ body: _body }) as HttpResponse<Array<{ country: string; count: number }>>;
      })
    );
  }

  managerReportsTicketsByCountry(body?: ReceiptForm): Observable<Array<{ country: string; count: number }>> {
    return this.managerReportsTicketsByCountryResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/sold-stats
   * Thống kê vé đã bán: prices động + rows theo ngày/tài khoản.
   */
  managerReportsTicketSoldStatsResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    active?: number;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.active != null) {
      __params = __params.set('active', params.active.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/sold-stats`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportsTicketSoldStats(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    active?: number;
  }): Observable<any> {
    return this.managerReportsTicketSoldStatsResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerExportExcelTicketSoldStatsResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    active?: number;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.active != null) {
      __params = __params.set('active', params.active.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/sold-stats/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelTicketSoldStats(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    active?: number;
  }): Observable<any> {
    return this.managerExportExcelTicketSoldStatsResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/reprint-stats
   * Thống kê vé in lại (ticket_reprint).
   */
  managerReportsTicketReprintStatsResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/reprint-stats`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportsTicketReprintStats(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
  }): Observable<any> {
    return this.managerReportsTicketReprintStatsResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerExportExcelTicketReprintStatsResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/reprint-stats/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelTicketReprintStats(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
  }): Observable<any> {
    return this.managerExportExcelTicketReprintStatsResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/reprint-detail
   * Chi tiết vé in lại — group serial + ticket_type_id.
   */
  managerReportsTicketReprintDetailResponse(params?: {
    from_date?: string;
    to_date?: string;
    page?: number;
    limit?: number;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.page != null) {
      __params = __params.set('page', params.page.toString());
    }
    if (params != null && params.limit != null) {
      __params = __params.set('limit', params.limit.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/reprint-detail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportsTicketReprintDetail(params?: {
    from_date?: string;
    to_date?: string;
    page?: number;
    limit?: number;
  }): Observable<any> {
    return this.managerReportsTicketReprintDetailResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerExportExcelTicketReprintDetailResponse(params?: {
    from_date?: string;
    to_date?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/reprint-detail/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelTicketReprintDetail(params?: {
    from_date?: string;
    to_date?: string;
  }): Observable<any> {
    return this.managerExportExcelTicketReprintDetailResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/check-control-stats
   * Thống kê vé kiểm soát (đã soát / chưa soát).
   * Params: from_date, to_date, check_status (all|checked|unchecked)
   */
  managerReportsTicketCheckControlStatsResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    check_status?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.check_status != null) {
      __params = __params.set('check_status', params.check_status.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/check-control-stats`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportsTicketCheckControlStats(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    check_status?: string;
  }): Observable<any> {
    return this.managerReportsTicketCheckControlStatsResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerExportExcelTicketCheckControlStatsResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    check_status?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.check_status != null) {
      __params = __params.set('check_status', params.check_status.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/check-control-stats/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelTicketCheckControlStats(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    check_status?: string;
  }): Observable<any> {
    return this.managerExportExcelTicketCheckControlStatsResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/sold-check-diff-stats
   * Chênh lệch vé bán / vé soát (service tái sử dụng check-control).
   */
  managerReportsTicketSoldCheckDiffStatsResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    check_status?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.check_status != null) {
      __params = __params.set('check_status', params.check_status.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/sold-check-diff-stats`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportsTicketSoldCheckDiffStats(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    check_status?: string;
  }): Observable<any> {
    return this.managerReportsTicketSoldCheckDiffStatsResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerExportExcelTicketSoldCheckDiffStatsResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    check_status?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.check_status != null) {
      __params = __params.set('check_status', params.check_status.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/sold-check-diff-stats/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelTicketSoldCheckDiffStats(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    check_status?: string;
  }): Observable<any> {
    return this.managerExportExcelTicketSoldCheckDiffStatsResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/revenue-stats
   * Doanh thu (service tái sử dụng sold-stats → amount).
   */
  managerReportsTicketRevenueStatsResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/revenue-stats`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportsTicketRevenueStats(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
  }): Observable<any> {
    return this.managerReportsTicketRevenueStatsResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerExportExcelTicketRevenueStatsResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/revenue-stats/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelTicketRevenueStats(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
  }): Observable<any> {
    return this.managerExportExcelTicketRevenueStatsResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/company-visitor-compare
   * So sánh lượt khách theo khách hàng. Mỗi kỳ là khoảng từ–đến (day|month|year).
   */
  managerReportsCompanyVisitorCompareResponse(params?: {
    period_type?: string;
    first_from?: string;
    first_to?: string;
    second_from?: string;
    second_to?: string;
    ticket_type_id?: number;
    search?: string;
    keywords?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.first_from != null) {
      __params = __params.set('first_from', params.first_from.toString());
    }
    if (params != null && params.first_to != null) {
      __params = __params.set('first_to', params.first_to.toString());
    }
    if (params != null && params.second_from != null) {
      __params = __params.set('second_from', params.second_from.toString());
    }
    if (params != null && params.second_to != null) {
      __params = __params.set('second_to', params.second_to.toString());
    }
    if (params != null && params.ticket_type_id != null) {
      __params = __params.set('ticket_type_id', params.ticket_type_id.toString());
    }
    if (params != null && params.search != null) {
      __params = __params.set('search', params.search.toString());
    }
    if (params != null && params.keywords != null) {
      __params = __params.set('keywords', params.keywords.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/company-visitor-compare`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportsCompanyVisitorCompare(params?: {
    period_type?: string;
    first_from?: string;
    first_to?: string;
    second_from?: string;
    second_to?: string;
    ticket_type_id?: number;
    search?: string;
    keywords?: string;
  }): Observable<any> {
    return this.managerReportsCompanyVisitorCompareResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerExportExcelCompanyVisitorCompareResponse(params?: {
    period_type?: string;
    first_from?: string;
    first_to?: string;
    second_from?: string;
    second_to?: string;
    ticket_type_id?: number;
    search?: string;
    keywords?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.first_from != null) {
      __params = __params.set('first_from', params.first_from.toString());
    }
    if (params != null && params.first_to != null) {
      __params = __params.set('first_to', params.first_to.toString());
    }
    if (params != null && params.second_from != null) {
      __params = __params.set('second_from', params.second_from.toString());
    }
    if (params != null && params.second_to != null) {
      __params = __params.set('second_to', params.second_to.toString());
    }
    if (params != null && params.ticket_type_id != null) {
      __params = __params.set('ticket_type_id', params.ticket_type_id.toString());
    }
    if (params != null && params.search != null) {
      __params = __params.set('search', params.search.toString());
    }
    if (params != null && params.keywords != null) {
      __params = __params.set('keywords', params.keywords.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/company-visitor-compare/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelCompanyVisitorCompare(params?: {
    period_type?: string;
    first_from?: string;
    first_to?: string;
    second_from?: string;
    second_to?: string;
    ticket_type_id?: number;
    search?: string;
    keywords?: string;
  }): Observable<any> {
    return this.managerExportExcelCompanyVisitorCompareResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/period-nationality-compare
   * So sánh quốc tịch. Mỗi kỳ là khoảng từ–đến (day|month|year).
   */
  managerReportsPeriodNationalityCompareResponse(params?: {
    period_type?: string;
    first_from?: string;
    first_to?: string;
    second_from?: string;
    second_to?: string;
    ticket_type_id?: number;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.first_from != null) {
      __params = __params.set('first_from', params.first_from.toString());
    }
    if (params != null && params.first_to != null) {
      __params = __params.set('first_to', params.first_to.toString());
    }
    if (params != null && params.second_from != null) {
      __params = __params.set('second_from', params.second_from.toString());
    }
    if (params != null && params.second_to != null) {
      __params = __params.set('second_to', params.second_to.toString());
    }
    if (params != null && params.ticket_type_id != null) {
      __params = __params.set('ticket_type_id', params.ticket_type_id.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/period-nationality-compare`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportsPeriodNationalityCompare(params?: {
    period_type?: string;
    first_from?: string;
    first_to?: string;
    second_from?: string;
    second_to?: string;
    ticket_type_id?: number;
  }): Observable<any> {
    return this.managerReportsPeriodNationalityCompareResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerExportExcelPeriodNationalityCompareResponse(params?: {
    period_type?: string;
    first_from?: string;
    first_to?: string;
    second_from?: string;
    second_to?: string;
    ticket_type_id?: number;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.first_from != null) {
      __params = __params.set('first_from', params.first_from.toString());
    }
    if (params != null && params.first_to != null) {
      __params = __params.set('first_to', params.first_to.toString());
    }
    if (params != null && params.second_from != null) {
      __params = __params.set('second_from', params.second_from.toString());
    }
    if (params != null && params.second_to != null) {
      __params = __params.set('second_to', params.second_to.toString());
    }
    if (params != null && params.ticket_type_id != null) {
      __params = __params.set('ticket_type_id', params.ticket_type_id.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/period-nationality-compare/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelPeriodNationalityCompare(params?: {
    period_type?: string;
    first_from?: string;
    first_to?: string;
    second_from?: string;
    second_to?: string;
    ticket_type_id?: number;
  }): Observable<any> {
    return this.managerExportExcelPeriodNationalityCompareResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/visitor-hourly-traffic
   * Lưu lượng khách theo giờ. Params: from_date, to_date, time_slots (JSON)
   */
  managerReportsVisitorHourlyTrafficResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    time_slots?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.time_slots != null) {
      __params = __params.set('time_slots', params.time_slots.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/visitor-hourly-traffic`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportsVisitorHourlyTraffic(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    time_slots?: string;
  }): Observable<any> {
    return this.managerReportsVisitorHourlyTrafficResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerExportExcelVisitorHourlyTrafficResponse(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    time_slots?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.period_type != null) {
      __params = __params.set('period_type', params.period_type.toString());
    }
    if (params != null && params.time_slots != null) {
      __params = __params.set('time_slots', params.time_slots.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/visitor-hourly-traffic/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelVisitorHourlyTraffic(params?: {
    from_date?: string;
    to_date?: string;
    period_type?: string;
    time_slots?: string;
  }): Observable<any> {
    return this.managerExportExcelVisitorHourlyTrafficResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/cancelled-detail
   * Chi tiết vé đã hủy — mỗi vé 1 dòng.
   */
  managerReportsTicketCancelledDetailResponse(params?: {
    from_date?: string;
    to_date?: string;
    page?: number;
    limit?: number;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    if (params != null && params.page != null) {
      __params = __params.set('page', params.page.toString());
    }
    if (params != null && params.limit != null) {
      __params = __params.set('limit', params.limit.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/cancelled-detail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportsTicketCancelledDetail(params?: {
    from_date?: string;
    to_date?: string;
    page?: number;
    limit?: number;
  }): Observable<any> {
    return this.managerReportsTicketCancelledDetailResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * GET /manager/reports/tickets/cancelled-detail/export
   */
  managerExportExcelTicketCancelledDetailResponse(params?: {
    from_date?: string;
    to_date?: string;
  }): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;
    if (params != null && params.from_date != null) {
      __params = __params.set('from_date', params.from_date.toString());
    }
    if (params != null && params.to_date != null) {
      __params = __params.set('to_date', params.to_date.toString());
    }
    const req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/cancelled-detail/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        const _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerExportExcelTicketCancelledDetail(params?: {
    from_date?: string;
    to_date?: string;
  }): Observable<any> {
    return this.managerExportExcelTicketCancelledDetailResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerDownloadTicketsByCountryResponse(body?: ReceiptForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (body.date_from != null) {
      __params = __params.set('from_date', body.date_from.toString());
    }
    if (body.date_to != null) {
      __params = __params.set('to_date', body.date_to.toString());
    }
    if ((body as any).market_type != null && (body as any).market_type !== '') {
      __params = __params.set('market_type', (body as any).market_type.toString());
    }
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/reports/tickets/by-country/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string;
        return _resp.clone({ body: _body }) as HttpResponse<string>;
      })
    );
  }

  managerReportsTicketGroupCheckResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if (body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.price_id != null) __params = __params.set("ticket_price_id", body.price_id.toString());
    if(body.type_check != null) __params = __params.set("type_check", body.type_check.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/tickets/group-check/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsTicketGroupCheck(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsTicketGroupCheckResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsGiftResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if (body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.opt != null) __params = __params.set("opt", body.opt.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/gift/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsGift(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsGiftResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerDownloadReportGiftResponse(
    body?: any
  ): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;

    let req = new HttpRequest<any>(
      "post",
      this.rootUrl + `/manager/reports/gift/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob"
      }
    );
    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string;
        return _resp.clone({ body: _body }) as HttpResponse<string>;
      })
    );
  }

  managerReportsDebtResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if (body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/debt/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsDebt(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsDebtResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerDownloadReportDebtResponse(
    body?: any
  ): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;

    let req = new HttpRequest<any>(
      "post",
      this.rootUrl + `/manager/reports/debt/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob"
      }
    );
    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string;
        return _resp.clone({ body: _body }) as HttpResponse<string>;
      })
    );
  }

  managerReportsHistoricalSitesTicketsResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if (body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if (body.historical_sites_id != null) __params = __params.set("historical_sites_id", body.historical_sites_id.toString());
    if (body.price_id != null) __params = __params.set("price_id", body.price_id.toString());
    if (body.opt != null) __params = __params.set("opt", body.opt.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    if (body != null && (body as any).is_cheat != null && (body as any).is_cheat !== '') {
      __params = __params.set("is_cheat", String((body as any).is_cheat));
    }
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/historical-sites-tickets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsHistoricalSitesTickets(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsHistoricalSitesTicketsResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsDetailHistoricalSitesTicketsResponse(id, from_date, to_date, is_cheat?: number): Observable<HttpResponse<ReceiptDetail>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (is_cheat === 1) {
      __params = __params.set('is_cheat', '1');
    }

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/historical-sites-tickets/detail/${id}/${from_date}/${to_date}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptDetail = null;
        _body = _resp.body as ReceiptDetail
        return _resp.clone({body: _body}) as HttpResponse<ReceiptDetail>;
      })
    );
  }

  /**
   * @param shiftId - undefined
   */
  managerReportsDetailHistoricalSitesTickets(id, from_date, to_date, is_cheat?: number): Observable<ReceiptDetail> {
    return this.managerReportsDetailHistoricalSitesTicketsResponse(id, from_date, to_date, is_cheat).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * @param body - undefined
   */
   managerReportsInvoicesResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if(body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.vehicle_id != null) __params = __params.set("vehicle_id", body.vehicle_id.toString());
    if(body.price_id != null) __params = __params.set("ticket_price_id", body.price_id.toString());
    if(body.ticket_counters_id != null) __params = __params.set("ticket_counters_id", body.ticket_counters_id.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/tickets/einvoice/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
   managerReportsInvoices(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsInvoicesResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsTicketViewResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if(body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.vehicle_id != null) __params = __params.set("vehicle_id", body.vehicle_id.toString());
    if(body.price_id != null) __params = __params.set("ticket_price_id", body.price_id.toString());
    if(body.ticket_counters_id != null) __params = __params.set("ticket_counters_id", body.ticket_counters_id.toString());
    if (body.page != null) __params = __params.set("page", body.page.toString());
    if (body.limit != null) __params = __params.set("limit", body.limit.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/tickets/ticketview/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsTicketView(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsTicketViewResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * @param body - undefined
   */
   managerReportsInvoiceSummaryResponse(body?: ReceiptForm): Observable<HttpResponse<ReceiptView[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    // __body = body;
    if (body.date != null) __params = __params.set("from_date", body.date.toString());
    if(body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.vehicle_id != null) __params = __params.set("vehicle_id", body.vehicle_id.toString());
    if(body.price_id != null) __params = __params.set("ticket_price_id", body.price_id.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/tickets/ticketsales/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: ReceiptView[] = null;
        _body = _resp.body as ReceiptView[]
        return _resp.clone({body: _body}) as HttpResponse<ReceiptView[]>;
      })
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsInvoiceSummary(body?: ReceiptForm): Observable<ReceiptView[]> {
    return this.managerReportsInvoiceSummaryResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  /**
 * @param body - undefined
 */
    managerReportsExportTicketSaleResponse(data:any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/tickets/ticketsales`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob',
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
    managerReportsExportTicketSale(data:any): Observable<string> {
    return this.managerReportsExportTicketSaleResponse(data).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsExportTicketSaleV2Response(data:any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/tickets/ticketsales/v2`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob',
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  managerReportsExportTicketSaleV2(data:any): Observable<string> {
    return this.managerReportsExportTicketSaleV2Response(data).pipe(
      map(_r => _r.body)
    );
  }

  
  /**
 * @param body - undefined
 */
  managerReportsExportTicketSaleAllResponse(data:any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/tickets/ticketsales`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob',
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
    managerReportsExportTicketSaleAll(data:any): Observable<string> {
    return this.managerReportsExportTicketSaleAllResponse(data).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsExportTicketSaleAllV2Response(data:any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/tickets/ticketsales/v2`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob',
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  managerReportsExportTicketSaleAllV2(data:any): Observable<string> {
    return this.managerReportsExportTicketSaleAllV2Response(data).pipe(
      map(_r => _r.body)
    );
  }

  managerReportsExportTicketGroupCheckResponse(body?: any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if (body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if(body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if(body.price_id != null) __params = __params.set("ticket_price_id", body.price_id.toString());
    if(body.type_check != null) __params = __params.set("type_check", body.type_check.toString());
    if(body.source != null) __params = __params.set("source", body.source.toString());
    if(body.ticket_counters_id != null) __params = __params.set("ticket_counters_id", body.ticket_counters_id.toString());
    if(body.month != null) __params = __params.set("month", body.month.toString());
    if(body.action != null) __params = __params.set("action", body.action.toString());
    
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/tickets/group-check/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob',
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  // GET export for Ticket Sale by Buyer
  managerExportTicketSaleByBuyerGetResponse(body?: any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (body && body.date_from != null) __params = __params.set("from_date", body.date_from.toString());
    if (body && body.date_to != null) __params = __params.set("to_date", body.date_to.toString());
    if (body && body.user_id != null) __params = __params.set("user_id", body.user_id.toString());
    if (body && body.price_id != null) __params = __params.set("ticket_price_id", body.price_id.toString());
    if (body && body.ticket_counters_id != null) __params = __params.set("ticket_counters_id", body.ticket_counters_id.toString());
    if (body && body.month != null) __params = __params.set("month", body.month.toString());

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/ticket-sale-buyer/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob',
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  managerExportTicketSaleByBuyerGet(data:any): Observable<string> {
    return this.managerExportTicketSaleByBuyerGetResponse(data).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * @param body - undefined
   */
  managerReportsExportTicketGroupCheck(data:any): Observable<string> {
    return this.managerReportsExportTicketGroupCheckResponse(data).pipe(
      map(_r => _r.body)
    );
  }

  managerPushTicketAllResponse(body?: EInvoiceForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/invoice/push/all`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  /**
   * @param body - undefined
   */
   managerPushTicketAll(body?: EInvoiceForm): Observable<string> {
    return this.managerPushTicketAllResponse(body).pipe(
      map(_r => _r.body)
    );
  }
  
  managerReportsEditDetailEinvoiceReponse(body?: EditEinvoiceForm): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/invoice/edit/ticket`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  managerReportsEditDetailEinvoice(body: EditEinvoiceForm): Observable<string> {
    return this.managerReportsEditDetailEinvoiceReponse(body).pipe(
      map(_r => _r.body)
    );
   }

  managerReportsUnlockDetailEinvoiceReponse(body?: any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/invoice/unlock/ticket`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  managerReportsUnlockDetailEinvoice(body: any): Observable<string> {
    return this.managerReportsUnlockDetailEinvoiceReponse(body).pipe(
      map(_r => _r.body)
    );
  }
   
  managerReportsPushTicketReponse(body?: any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/summary/invoice/push/ticket`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string
        return _resp.clone({body: _body}) as HttpResponse<string>;
      })
    );
  }

  managerReportsPushTicket(body: any): Observable<string> {
    return this.managerReportsPushTicketReponse(body).pipe(
      map(_r => _r.body)
    );
  }


  managerDetailEinvoiceGroupResponse(e_invoice_group_id?: any): Observable<HttpResponse<any[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
  
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/e-invoice-groups/detail/${e_invoice_group_id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: any[] = null;
        _body = _resp.body as any[]
        return _resp.clone({body: _body}) as HttpResponse<any[]>;
      })
    );
  }
  /**
   * @param page - The number of items to skip before starting to collect the result set.
   * @param limit - The numbers of items to return.
   * @param disable - The numbers of items to return.
   */
  managerDetailEinvoiceGroup(param: any): Observable<any[]> {
    return this.managerDetailEinvoiceGroupResponse(param).pipe(
      map(_r => _r.body)
    );
  }

  managerExportEinvoiceGroupResponse(body: any): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/reports/e-invoice-groups/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

      return this.http.request<any>(req).pipe(
        filter(_r => _r instanceof HttpResponse),
        map(_r => {
          let _resp = _r as HttpResponse<any>;
          let _body: string = null;
          _body = _resp.body as string;
          return _resp.clone({ body: _body }) as HttpResponse<string>;
        })
      );
  }

  managerExportDetailEinvoiceGroupResponse(e_invoice_group_id): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/reports/e-invoice-groups/export/${e_invoice_group_id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

      return this.http.request<any>(req).pipe(
        filter(_r => _r instanceof HttpResponse),
        map(_r => {
          let _resp = _r as HttpResponse<any>;
          let _body: string = null;
          _body = _resp.body as string;
          return _resp.clone({ body: _body }) as HttpResponse<string>;
        })
      );
  }

  managerDownloadHistoricalSitesTicketsResponse(
    body?: any
  ): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;

    let req = new HttpRequest<any>(
      "post",
      this.rootUrl + `/manager/historical-sites-tickets/export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob"
      }
    );
    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string;
        return _resp.clone({ body: _body }) as HttpResponse<string>;
      })
    );
  }

  managerDownloadHistoricalSitesTicketsGroupedResponse(
    body?: any
  ): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;

    let req = new HttpRequest<any>(
      "post",
      this.rootUrl + `/manager/historical-sites-tickets/export-grouped`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob"
      }
    );
    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string;
        return _resp.clone({ body: _body }) as HttpResponse<string>;
      })
    );
  }

  managerDownloadDetailHistoricalSitesTicketsResponse(
    body?: any
  ): Observable<HttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;

    let req = new HttpRequest<any>(
      "post",
      this.rootUrl + `/manager/historical-sites-tickets/export-detail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob"
      }
    );
    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: string = null;
        _body = _resp.body as string;
        return _resp.clone({ body: _body }) as HttpResponse<string>;
      })
    );
  }

  managerReportTicketPaymentsSummaryResponse(body?: any): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (body != null && body.date_from != null) {
      __params = __params.set('from_date', body.date_from.toString());
    }
    if (body != null && body.date_to != null) {
      __params = __params.set('to_date', body.date_to.toString());
    }
    if (body != null && body.user_id != null && body.user_id !== '') {
      __params = __params.set('user_id', body.user_id.toString());
    }
    if (body != null && body.page != null) {
      __params = __params.set('page', body.page.toString());
    }
    if (body != null && body.limit != null) {
      __params = __params.set('limit', body.limit.toString());
    }

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/ticket-payments/report`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportTicketPaymentsSummary(body?: any): Observable<any> {
    return this.managerReportTicketPaymentsSummaryResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerReportTicketPaymentsDetailResponse(body?: any): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (body != null && body.user_id != null) {
      __params = __params.set('user_id', body.user_id.toString());
    }
    if (body != null && body.date_from != null) {
      __params = __params.set('from_date', body.date_from.toString());
    }
    if (body != null && body.date_to != null) {
      __params = __params.set('to_date', body.date_to.toString());
    }

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manager/ticket-payments/report/detail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerReportTicketPaymentsDetail(body?: any): Observable<any> {
    return this.managerReportTicketPaymentsDetailResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerDeleteTicketPaymentResponse(id: number): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/manager/ticket-payments/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        return _resp.clone({ body: _resp.body }) as HttpResponse<any>;
      })
    );
  }

  managerDeleteTicketPayment(id: number): Observable<any> {
    return this.managerDeleteTicketPaymentResponse(id).pipe(
      map(_r => _r.body)
    );
  }

}


export module ManagerReportsService {
  export interface ManagerlistTicketParams {
    user_id?: number;
    from_date?: string;
    to_date?: string;
  }
  export interface ManagerTicketParams {
    ticket_id?:number;
  }
}
